import { render, staticRenderFns } from "./WHLanguage.vue?vue&type=template&id=d19807d2&"
import script from "./WHLanguage.vue?vue&type=script&lang=js&"
export * from "./WHLanguage.vue?vue&type=script&lang=js&"
import style0 from "./WHLanguage.vue?vue&type=style&index=0&id=d19807d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports